import favicon from "../assets/branding/aafavicon.png";

// 2026-10-28: ArtistNav branding on ArtistNav domains; the old ArtistAscend look stays on artistascend.app.
const IS_ARTISTNAV = typeof window !== "undefined" && window.location.hostname.endsWith("artistnav.com");
const BRAND = IS_ARTISTNAV ? "ArtistNav" : "ArtistAscend";
const BRAND_ICON = IS_ARTISTNAV ? "/artistnav-icon.png" : favicon;
const HOME_HREF = IS_ARTISTNAV ? "/" : "/hello";

export default function NotFoundPublic() {
  return (
    <div className="launch-root" style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <div className="launch-hero-bg" aria-hidden="true" />

      <header className="launch-shell">
        <div className="launch-header">
          <a href={HOME_HREF} className="launch-logo" style={{ textDecoration: "none", color: "inherit" }}>
            <img className="launch-logo-mark" src={BRAND_ICON} alt={`${BRAND} icon`} />
            <span className="launch-logo-text">{BRAND}</span>
          </a>
          <div className="launch-header-cta">
            <a className="launch-btn launch-btn--ghost" href={window.location.hostname.endsWith("artistnav.com") ? "https://app.artistnav.com/login" : "https://agents.artistascend.app/login"}>Sign In</a>
          </div>
        </div>
      </header>

      <main className="launch-shell" style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center", padding: "80px 24px" }}>
        <div style={{ maxWidth: 480 }}>
          <h1 className="launch-display" style={{ fontSize: "clamp(2rem, 4vw, 3rem)", marginBottom: 16 }}>
            Page not found
          </h1>
          <p className="launch-lead" style={{ marginBottom: 28 }}>
            The page you&rsquo;re looking for doesn&rsquo;t exist or has been moved.
          </p>
          <a className="launch-btn" href={HOME_HREF}>
            Back to homepage
          </a>
        </div>
      </main>

      <footer className="launch-shell launch-footer">
        <p className="launch-footer-note">&copy; 2026 {BRAND}. All rights reserved.</p>
      </footer>
    </div>
  );
}
